exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-1b35df6c]{padding:20px}[data-v-1b35df6c] .el-form-item--medium .el-form-item__label{line-height:32px;margin-left:10px}\n", ""]);

// exports
